export default __webpack_public_path__ + "static/media/image.nallathu.2fd103ed.png";